import { ActionBar, CalendarIcon, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { visitActionBarTranslationKeys, visitTranslationKeys } from '../../translations';

import { VisitActionBarOrder } from './VisitActionBar';

type GoToNextVisitActionProps = {
   readonly patientId: number;
};

export const GoToNextVisitAction = (props: GoToNextVisitActionProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(true);

   const onClick = (): void =>
      push(
         visitPaths.getCalendarPath({
            searchParams: {
               bookPatientId: props.patientId,
            },
         }),
         {
            label: visitTranslationKeys.goBackToVisit,
         }
      );

   return (
      <ActionBar.OptionalLink
         testId={'goToCalendar'}
         icon={<CalendarIcon />}
         label={visitActionBarTranslationKeys.nextVisit}
         onClick={onClick}
         order={VisitActionBarOrder.NextVisit}
         nowrap
      />
   );
};
